export function sanitizeFormValues(values) {
  if (!values || typeof values !== 'object') {
    return {};
  }

  return Object.entries(values).reduce((acc, [key, value]) => {
    if (typeof value === 'string') {
      acc[key] = isUrl(value) ? sanitizeURL(value) : sanitizeString(value);
    } else {
      // keep numbers, booleans, arrays, objects as-is
      acc[key] = value;
    }
    return acc;
  }, {});
}

function stripHtml(input) {
  const doc = new DOMParser().parseFromString(input, 'text/html');
  return doc.body.textContent || '';
}

function sanitizeString(str) {
  if (typeof str !== 'string' || !str.trim()) {
    return '';
  }

  let sanitized = str.trim();

  // --- 1️ Remove <script> tags safely ---
  // This regex removes script blocks without catastrophic backtracking
  sanitized = sanitized.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');

  // --- 2️ Remove all other HTML tags ---
  // Linear-time tag stripper. This is safe for reasonably sized input.
  sanitized = stripHtml(sanitized);
  // --- 3️ Remove known dangerous patterns ---
  const dangerousPatterns = [
    /\bjavascript:/gi, // JS protocol
    /\bvbscript:/gi, // VBScript protocol
    /\bdata:\s*text\/html/gi, // Data URI HTML
    /\bon\w+\s*=/gi, // Inline event handlers
    /\beval\s*\(/gi, // eval()
    /\balert\s*\(/gi, // alert()
    /\bdocument\.cookie/gi, // cookie access
    /\bexpression\s*\(/gi, // CSS expressions
  ];

  for (const pattern of dangerousPatterns) {
    sanitized = sanitized.replace(pattern, '');
  }

  // --- 4️ Escape HTML entities ---
  const entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;',
  };

  sanitized = sanitized.replace(/[&<>"'/`=]/g, match => entityMap[match]);

  // --- 5️ Normalize excessive whitespace ---
  sanitized = sanitized.replace(/\s{2,}/g, ' ');

  return sanitized;
}

function sanitizeURL(url) {
  if (!url) {
    return '';
  }

  let sanitized = url.trim();

  // Strip HTML tags (safe, linear-time regex)
  sanitized = stripHtml(sanitized);

  // Prevent dangerous protocols
  const blockedProtocols = [/^javascript:/i, /^vbscript:/i, /^data:\s*text\/html/i];
  blockedProtocols.forEach(pattern => {
    if (pattern.test(sanitized)) {
      sanitized = '';
    }
  });

  return sanitized;
}

// Safe URL check
function isUrl(str) {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
}
